var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRefreshMenuIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 4C0 1.79086 1.79086 0 4 0H10C12.2091 0 14 1.79086 14 4V10C14 12.2091 12.2091 14 10 14H4C1.79086 14 0 12.2091 0 10V4Z",
    fill: "#721C31"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.34221 5.34485C7.99483 5.07274 7.5731 4.85714 7.0643 4.85714C5.85547 4.85714 4.87552 5.81653 4.87552 7C4.87552 8.18346 5.85547 9.14286 7.0643 9.14286C8.01421 9.14286 8.82351 8.55011 9.12603 7.7216C9.18028 7.573 9.33335 7.47337 9.49103 7.50609L9.77651 7.56534C9.93419 7.59806 10.0363 7.75034 9.98792 7.90089C9.59708 9.11749 8.43641 10 7.0643 10C5.37194 10 4 8.65686 4 7C4 5.34315 5.37194 4 7.0643 4C7.87664 4 8.50937 4.36242 8.96452 4.7356L9.48449 4.22654C9.56796 4.14483 9.69348 4.12038 9.80254 4.16461C9.9116 4.20883 9.98269 4.31301 9.98269 4.42857V6C9.98269 6.15779 9.85203 6.28571 9.69085 6.28571H8.08574C7.96772 6.28571 7.86129 6.2161 7.81611 6.10934C7.77096 6.00257 7.79592 5.87968 7.87938 5.79797L8.34221 5.34485Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefreshMenuIcon);
export default __webpack_public_path__ + "static/media/refresh-menu-icon.038ec4b7f7526cc1961d56c5e1e7717f.svg";
export { ForwardRef as ReactComponent };